import i18n from '@/i18n';

export const toggleLanguage = () => {
  const newLang = i18n.language === 'ko' ? 'en' : 'ko';
  i18n.changeLanguage(newLang);
};
